import axios from "axios";
import { BASE_URL } from "../constant/api";

export const TrendingProductsFetchApi = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/products/trending/`);
      console.log(response.data);
  
      return response.data;
    } catch (error) {
      console.log("error in TrendingProductsFetchApi", error);
      throw error;
    }
  };